// ช่วยอ่าน template ของ WhatsApp (โครงสร้างตาม Meta: components = HEADER / BODY / FOOTER / BUTTONS)
// API คืนชื่อ field ได้ทั้งแบบ camelCase และ snake_case จึงอ่านทั้งสองแบบ

export const WHATSAPP_WINDOW_HOURS = 24;

// error code จาก WhatsApp → คำอธิบายสั้น ๆ สำหรับแสดงใต้ข้อความที่ส่งไม่สำเร็จ
export const WHATSAPP_SEND_ERRORS = {
  131047: "เกิน 24 ชม. ลูกค้าต้องทักมาก่อน หรือส่งเป็น Template",
  131049: "WhatsApp จำกัดการส่ง Template การตลาดหาลูกค้ารายนี้",
  131026: "ส่งไม่ถึงเบอร์นี้ (ไม่ได้ใช้ WhatsApp)",
  131042: "บัญชี WhatsApp Business มีปัญหาการชำระเงิน",
  131056: "ส่งหาลูกค้ารายนี้ถี่เกินไป",
  132000: "จำนวนตัวแปรของ Template ไม่ตรงกัน",
  132001: "ไม่พบ Template นี้ หรือยังไม่ได้รับอนุมัติ",
  132015: "Template ถูกระงับเพราะคุณภาพต่ำ",
  132016: "Template ถูกปิดใช้งาน"
};

export const sendErrorText = code =>
  code ? WHATSAPP_SEND_ERRORS[code] || `ส่งไม่สำเร็จ (code ${code})` : "";

export const CATEGORY_INFO = {
  UTILITY: {
    label: "Utility",
    variant: "success",
    note:
      "ข้อความแจ้งเรื่องที่ลูกค้าทำค้างไว้ เช่น ออเดอร์ นัดหมาย ไม่จำกัดจำนวนครั้ง"
  },
  MARKETING: {
    label: "Marketing",
    variant: "warning",
    note:
      "WhatsApp จำกัดจำนวน Template การตลาดที่ลูกค้าแต่ละคนได้รับ ถ้าส่งบ่อยอาจไม่ถึงลูกค้า"
  },
  AUTHENTICATION: {
    label: "Authentication",
    variant: "secondary",
    note: "ใช้ส่งรหัส OTP เท่านั้น"
  }
};

const VARIABLE_REGEX = /{{\s*(\d+)\s*}}/g;
const HAS_VARIABLE_REGEX = /{{\s*\d+\s*}}/;
const NAMED_VARIABLE_REGEX = /{{\s*[a-zA-Z_][a-zA-Z0-9_]*\s*}}/;

export const findComponent = (template, type) =>
  (template.components || []).find(c => (c.type || "").toUpperCase() === type);

// จำนวนตัวแปร {{1}}..{{n}} ในข้อความ
export const countVariables = text => {
  if (!text) return 0;
  const numbers = [...text.matchAll(VARIABLE_REGEX)].map(m => Number(m[1]));
  return numbers.length ? Math.max(...numbers) : 0;
};

export const renderText = (text, values = []) =>
  (text || "").replace(VARIABLE_REGEX, (match, n) => {
    const value = values[Number(n) - 1];
    return value && value.trim() ? value : match;
  });

// ตอนนี้ส่งได้เฉพาะ template ที่มีแค่ตัวแปรข้อความแบบตัวเลข → คืนเหตุผลถ้ายังส่งไม่ได้
export const unsupportedReason = template => {
  const format = (
    template.parameterFormat ||
    template.parameter_format ||
    ""
  ).toUpperCase();
  if (format === "NAMED") return "ใช้ตัวแปรแบบตั้งชื่อ ยังไม่รองรับ";

  const header = findComponent(template, "HEADER");
  if (header && (header.format || "TEXT").toUpperCase() !== "TEXT")
    return "มีรูป/วิดีโอ/ไฟล์ในหัวข้อ ยังไม่รองรับ";

  const texts = (template.components || []).map(c => c.text || "").join(" ");
  if (NAMED_VARIABLE_REGEX.test(texts))
    return "ใช้ตัวแปรแบบตั้งชื่อ ยังไม่รองรับ";

  const buttons = (findComponent(template, "BUTTONS") || {}).buttons || [];
  const hasDynamicButton = buttons.some(
    b =>
      (b.url && HAS_VARIABLE_REGEX.test(b.url)) ||
      !["QUICK_REPLY", "URL", "PHONE_NUMBER"].includes(
        (b.type || "").toUpperCase()
      )
  );
  if (hasDynamicButton) return "มีปุ่มที่ต้องใส่ค่าเพิ่ม ยังไม่รองรับ";
  return "";
};

// ข้อความที่จะแสดงในห้องแชท (หัวข้อ + เนื้อหา + ท้ายข้อความ) หลังแทนค่าตัวแปร
export const renderTemplateText = (template, headerValues, bodyValues) => {
  const header = findComponent(template, "HEADER");
  const body = findComponent(template, "BODY");
  const footer = findComponent(template, "FOOTER");
  return [
    header && header.text ? `*${renderText(header.text, headerValues)}*` : "",
    body ? renderText(body.text, bodyValues) : "",
    footer && footer.text ? `_${footer.text}_` : ""
  ]
    .filter(Boolean)
    .join("\n");
};
